import HotelCardExploreButton from './HotelCardExploreButton';

export default HotelCardExploreButton;
